<template>
	<div>
		<div v-for="item in newItems.filter(element => (fictive && !removedFictiveProducts.includes(element.product_id)) || !fictive)" class="b-basket__item" :class="{loading: isLoadingItem(item)}" :key="item.product_id + '-'+item.id">
			<a @click="removeItem(item)" href="javascript:void(0);" class="b-basket__itemRemove" :title="loc.CITRUS_VUE_BASKET_ITEMS_DELETE">
				<i class="icon icon--minus"></i>
				<i class="icon icon--plus"></i>
			</a>

			<div class="b-basket__itemWrap">
				<a v-if="item.detail_page_url" class="b-basket__itemName" :href="item.detail_page_url"
				   v-html="item.name"></a>
				<span v-else class="b-basket__itemName" v-html="item.name"></span>
				<div class="b-basket__itemFooter">
					<div class="b-basket__main">
						<div class="b-basket__stock" v-if="item.stock && isViewStock">
							<span v-if="item.stock.enable" v-html="loc.CITRUS_VUE_BASKET_ITEMS_IN_STOCK.replace('#COUNT#', item.stock.count)"></span>
							<span v-else v-html="loc.CITRUS_VUE_BASKET_ITEMS_IN_STOCK_MANY"></span>
						</div>
						<citrus-product-basket-quantity
							v-if="!viewMode"
							:class="'b-counter_catalog b-counter_basket'"
							:id="item.product_id"
							:quantity="item.quantity"
							@change="tryChangeQuantity($event, item)"
						></citrus-product-basket-quantity>
						<div v-else>
							<span v-html="item.quantity"></span>
							<span v-html="'шт.'"></span>
						</div>
					</div>
					<div class="b-price b-price_basket b-basket__itemPrice">
						<div class="b-price__item b-price__item_old" v-if="item.full_sum && item.full_sum > item.sum">
							<span v-html="formatPrice(item.full_sum, true, item.currency)"></span><span
							class="icon icon--ruble b-price__currency"></span>
						</div>
						<div class="b-price__item b-price__item_current">
							<span v-html="formatPrice(item.sum, true, item.currency)"></span><span
							class="icon icon--ruble b-price__currency"></span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<magnific-popup :config="{closeOnBgClick:false}"
		                ref="popupModal"
		                class="modal-content modal-w-1000 b-modal b-modal_order b-modal_stock"
		                v-if="isPopupOpened"
		                @close="onClosePopup(currentItem)"
		>
			<div>
				<div class="b-order__subtitle b-title_center">
					<span v-html="modalText()"></span>
				</div>

				<div class="b-modal__footer b-modal__footer_col">
					<button
						type="button"
						class="b-btn b-btn_primary b-modal__btn"
						v-html="loc.CITRUS_VUE_BASKET_ITEMS_CHANGE_DATE"
						@click="setDefaultDeliveryTime(currentItem)"
					></button>
					<button
						type="button"
						class="b-btn b-btn_transparent b-modal__btn"
						v-html="loc.CITRUS_VUE_BASKET_ITEMS_LESS_COUNT"
						@click="setMaxQuantity(currentItem)"
					></button>
				</div>
			</div>
		</magnific-popup>
	</div>
</template>
<script>
	import {Vue} from "ui.vue";
	import {store} from "citrus.vuex.store";
	import {FormatMixin} from "citrus.vue.mixin.format";
	import "citrus.vue.product.basket-button";
	import "citrus.plugins.magnific";

	/**
	 * Код куки, в которой хранятся удаленные товары-приборы (фиктивные товары корзины)
	 * @type {string}
	 */
	const REMOVED_FICTIVE_PRODUCT_CODE = "removedFictiveProduct";

	/**
	 * Код куки, в которой хранятся выбранные настройки даты доставки
	 * @type {string}
	 */
	const DELIVERY_TIME_CHECKED = "savedDeliveryTime";

	/**
	 * Код глобального Vue события для перерисовка нескольких корзин на странице (Когда размешено в шапке и на странице)
	 * @type {string}
	 */
	const FICTIVE_PRODUCT_UPDATED_EVENT = "Citrus.Vue.Basket.FictiveProducts:update";

	export default {
		name: "BasketItems",
		store: store,
		mixins: [FormatMixin],
		props: {
			viewMode: {
				type: [Boolean],
				default: false
			},
			items: {
				type: [Object, Array],
				default: function () {
					return []
				}
			},
			fictive: {
				type: [Boolean],
				default: false
			},
		},
		watch: {
			items: function () {
				this.newItems = Object.assign(this.items);
			}
		},
		data: function () {
			return {
				request: false,
				newRequestCount: 0,
				removedFictiveProducts: [],
				currentItem: {},
				desiredQuantity: '',
				isPopupOpened: false,
				useDeliveryTime: false,
				newItems: Object.assign(this.items)
			};
		},
		created: function () {
			this.loadRemovedFictiveProducts();

			Vue.event.$on(FICTIVE_PRODUCT_UPDATED_EVENT, this.loadRemovedFictiveProducts);

			if (!this.fictive) {
				Vue.event.$on("Citrus.Vue.Product:changedBasket", this.onChangeFromCatalog);
			}
		},
		beforeDestroy() {
			Vue.event.$off(FICTIVE_PRODUCT_UPDATED_EVENT, this.loadRemovedFictiveProducts);

			if (!this.fictive) {
				Vue.event.$off("Citrus.Vue.Product:changedBasket", this.onChangeFromCatalog);
			}
		},
		computed: {
			loc() {
				return Vue.getFilteredPhrases("CITRUS_VUE_BASKET_ITEMS_");
			},
			isViewStock() {
				return this.$store.getters['basket/isViewStock'];
			},
			orderStock() {
				return this.$store.getters['basket/orderStock'];
			}
		},
		methods: {
			isLoadingItem(item) {
				return this.$store.getters['basket/loading'](item.product_id);
			},
			removeItem: function (item) {
				if (this.fictive) {
					setTimeout(() => {
						this.onRemoveFictive(item.product_id);
					}, 300);
					return;
				}

				if (!this.isLoadingItem(item)) {
					this.$store.dispatch("basket/remove", item.product_id);
				}
			},
			onChangeFromCatalog(params) {
				let elem = this.newItems.find(el => el['product_id'] === params.id);
				this.changeQuantity(params, elem);
			},
			tryChangeQuantity: function (params, item) {
				/* Если нет активных запросов */
				if (!this.request) {
					this.request = true;
				} else {
					this.newRequestCount++; /* счетчик одновременных запросов */
				}

				setTimeout(() => {
					/* К данному моменту есть новый запрос */
					if (this.newRequestCount) {
						this.newRequestCount--;
						return false;
					}

					if (this.fictive) {
						let productId = (typeof params == "object" && params.hasOwnProperty("id"))
							? parseInt(params.id)
							: parseInt(params);

						this.onRemoveFictive(productId);
					}

					/* отправка запроса */
					this.changeQuantity(params, item);
					this.request = false;
					/* отправка запроса */

				}, 300);
			},
			changeQuantity: function (params, item) {
				let elemIndex = this.newItems.findIndex(elem => {return elem.product_id == params.id});
				this.newItems[elemIndex].quantity = params.quantity;

				if(!this.fictive && item.stock.enable) {

					this.currentItem = Object.assign(item);

					let dateWarning = this.showDateWarning(this.currentItem);

					if(params.quantity > item.stock.count && dateWarning) {
						this.desiredQuantity = params.quantity;
						this.isPopupOpened = true;

						setTimeout(() => {
							if (this.$refs.hasOwnProperty("popupModal")) {
								this.$refs.popupModal.openModal();
							}
						}, 100);
					} else {
						this.$store.dispatch("basket/change", params);
					}
				} else {
					this.$store.dispatch("basket/change", params);
				}
			},
			onRemoveFictive(product_id) {
				this.loadRemovedFictiveProducts();
				this.removedFictiveProducts.push(product_id);

				BX.setCookie(REMOVED_FICTIVE_PRODUCT_CODE, JSON.stringify(this.removedFictiveProducts), {path: BX.message('SITE_DIR')});

				Vue.event.$emit("Citrus.Vue.Basket.FictiveProducts:update");
			},
			loadRemovedFictiveProducts() {
				let removedFictiveProducts = BX.getCookie(REMOVED_FICTIVE_PRODUCT_CODE);

				this.removedFictiveProducts = removedFictiveProducts
					? JSON.parse(removedFictiveProducts)
					: [];
			},
			setDefaultDeliveryTime(item) {
				this.useDeliveryTime = true;
				let result = {'DELIVERY_TIME': "select_time", 'PICKUP_TIME': `${this.orderStock.min_date} ${this.orderStock.min_time}`};
				let params = {id: item.id, quantity: this.desiredQuantity};

				this.$emit('change-delivery-time', result);
				this.$store.dispatch('basket/toggleViewStock', false);
				BX.setCookie(DELIVERY_TIME_CHECKED, JSON.stringify(result), this.getCookieOptions());

				//setTimeout(() => {
					this.$store.dispatch("basket/change", params);
				//}, 100);

				this.isPopupOpened = false;
				this.$refs.popupModal.closeModal();
			},
			setMaxQuantity(item) {
				this.useDeliveryTime = false;
				let params = {id: item.id, quantity: item.stock.count};

				this.$store.dispatch('basket/toggleViewStock', true);
				//BX.setCookie(DELIVERY_TIME_CHECKED, '', this.getCookieOptions());

				this.$store.dispatch("basket/change", params);
				this.isPopupOpened = false;
				this.$refs.popupModal.closeModal();
			},
			// domain нужен, чтобы кука распространялась на поддомены тоже
			getCookieOptions() {
				return {path: BX.message("SITE_DIR"), domain: document.domain};
			},
			onClosePopup(item) {
				if (this.useDeliveryTime) {
					this.isPopupOpened = false;
					return;
				}

				this.setMaxQuantity(item);
			},
			getDeliveryTimeCookie() {
				return BX.getCookie("savedDeliveryTime") ? JSON.parse(BX.getCookie("savedDeliveryTime")) : null;
			},
			showDateWarning(item) {
				let deliveryTimeCookie = this.getDeliveryTimeCookie();

				console.log('deliveryTimeCookie', deliveryTimeCookie);

				if (!deliveryTimeCookie || deliveryTimeCookie.DELIVERY_TIME === 'now') {
					return true;
				}

				if (deliveryTimeCookie.PICKUP_TIME !== '') {
					let pickupTime = deliveryTimeCookie.PICKUP_TIME;

					// ожидаемый формат получаемой даты 01.01.2023
					let chosenDateArray = pickupTime.split(' ');
					let chosenDate = chosenDateArray[0].split('.').reverse().join('-');
					let formattedChosenDate = chosenDate + 'T' + chosenDateArray[1];
					formattedChosenDate = new Date(formattedChosenDate);
					formattedChosenDate.setMinutes(formattedChosenDate.getMinutes() + this.$store.getters['basket/orderMakeMinutes']);

					let availableDate = this.orderStock.min_date.split('.').reverse().join('-');
					let formattedAvailableDate = availableDate + `T${this.orderStock.min_time}`;

					let isDateWarning = formattedChosenDate.getTime() < new Date(formattedAvailableDate).getTime()

					return isDateWarning;
				}

				return false;
			},
			modalTextDescription() {
				return BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
					? BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
					: "";
			},
			modalText() {
				return BX.message.CITRUS_QUANTITY_TRACE_POPUP_LIMITED
					.replace("#MIN_DELIVERY_DATE#", `${this.orderStock.min_date} ${this.orderStock.min_time}`)
					.replace("#COUNT#", this.currentItem.stock.count)
					.replace("#PRODUCT_NAME#", this.currentItem.name)
			},
		},
	}
</script>